import { axios } from '@/plugins/axios-pol'

const basePath = '/desarrollopolicial/api/DesarrolloPolicial'

export default class ConvocatoriaApiRepository {
  // CONVOCATORIAS TIPOS
  async getAllTiposConvocatoria() {
    const { data } = await axios.get(`${basePath}/tipoConvocatoria`)
    return data.data
  }

  async getTipoConvocatoriaById(id) {
    const { data } = await axios.get(`${basePath}/tipoConvocatoria/${id}`)
    return data.data
  }

  // CONVOCATORIAS SUBTIPOS (POR TIPO)
  async getSubtiposConvocatoriaByTipo(idTipoConvocatoria) {
    const { data } = await axios.get(`${basePath}/tipoConvocatoria/${idTipoConvocatoria}/subtipoConvocatoria`)
    return data.data
  }

  async getSubtipoConvocatoriaByTipoAndId(idTipoConvocatoria, id) {
    const { data } = await axios.get(`${basePath}/tipoConvocatoria/${idTipoConvocatoria}/subtipoConvocatoria/${id}`)
    return data.data
  }

  // CONVOCATORIAS SUBTIPOS (GENERALES)
  async getAllSubtiposConvocatoria() {
    const { data } = await axios.get(`${basePath}/subtipoConvocatoria`)
    return data.data
  }

  async getSubtipoConvocatoriaById(id) {
    const { data } = await axios.get(`${basePath}/subtipoConvocatoria/${id}`)
    return data.data
  }

  // CONVOCATORIAS GRADOS DE PROMOCIÓN
  async getAllGradosPromocion() {
    const { data } = await axios.get(`${basePath}/gradoPromociones`)
    return data.data
  }

  async getGradoPromocionById(id) {
    const { data } = await axios.get(`${basePath}/gradoPromociones/${id}`)
    return data.data
  }

  // CONVOCATORIAS DIRIGIDO A
  async getAllDirigidos() {
    const { data } = await axios.get(`${basePath}/dirigido`)
    return data.data
  }

  async getDirigidoById(id) {
    const { data } = await axios.get(`${basePath}/dirigido/${id}`)
    return data.data
  }

  // CONVOCATORIAS
  async getAllConvocatorias() {
    const { data } = await axios.get(`${basePath}/convocatoria`)
    return data.data
  }

  async getConvocatoriaById(idConvocatoria) {
    const { data } = await axios.get(`${basePath}/convocatoria/${idConvocatoria}`)
    return data.data
  }

  async getConvocatoriasBySubtipo(idSubTipo) {
    const { data } = await axios.get(`${basePath}/subtipo/${idSubTipo}/convocatoria`)
    return data.data
  }

  async getConvocatoriaBySubtipoAndId(idSubTipo, idConvocatoria) {
    const { data } = await axios.get(`${basePath}/subtipo/${idSubTipo}/convocatoria/${idConvocatoria}`)
    return data.data
  }

  async createConvocatoria(payload) {
    const body = this.#buildConvocatoriaFormData(payload)
    const { data } = await axios.post(`${basePath}/convocatoria`, body)
    return data.data
  }

  async updateConvocatoria(idConvocatoria, payload) {
    const body = this.#buildConvocatoriaFormData(payload)
    const { data } = await axios.put(`${basePath}/convocatoria/${idConvocatoria}`, body)
    return data.data
  }

  // El backend solo persiste el registro cuando el body llega como
  // multipart/form-data; enviado como JSON responde 200 pero guarda el
  // registro vacío. Por eso siempre se construye FormData, con o sin adjunto.
  // Los valores null/undefined se envían como '' (en vez de omitirse) para
  // que el backend limpie el campo, igual que hacía el payload JSON previo
  // con fk_idGradoPromocion: null.
  #buildConvocatoriaFormData(payload) {
    const formData = new FormData()
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value === null || value === undefined ? '' : value)
    })

    return formData
  }

  // CONVOCATORIAS PERSONAL
  async getAllConvocatoriasPersonal() {
    const { data } = await axios.get(`${basePath}/convocatoriaPersonal`)
    return data.data
  }

  async getConvocatoriasPersonalByPersonalId(idPersonal) {
    const { data } = await axios.get(`${basePath}/personal/${idPersonal}/convocatoriaPersonal`)
    return data.data
  }

  async getConvocatoriaPersonalByPersonalIdAndId(idPersonal, idConvocatoriaPersonal) {
    const { data } = await axios.get(
      `${basePath}/personal/${idPersonal}/convocatoriaPersonal/${idConvocatoriaPersonal}`
    )
    return data.data
  }

  async createPersonalConvocatoria(idPersonal, payload) {
    const { data } = await axios.post(`${basePath}/personal/${idPersonal}/convocatoriaPersonal`, payload)
    const result = typeof data.data === 'string' ? JSON.parse(data.data) : data.data

    return result
  }

  async updatePersonalConvocatoria(idPersonal, idConvocatoriaPersonal, payload) {
    const { data } = await axios.put(
      `${basePath}/personal/${idPersonal}/convocatoriaPersonal/${idConvocatoriaPersonal}`,
      payload
    )
    const result = typeof data.data === 'string' ? JSON.parse(data.data) : data.data

    return result
  }

  async deletePersonalConvocatoria(idPersonal, idConvocatoriaPersonal) {
    const { data } = await axios.put(
      `${basePath}/personal/${idPersonal}/convocatoriaPersonal/${idConvocatoriaPersonal}/delete`
    )
    const result = typeof data.data === 'string' ? JSON.parse(data.data) : data.data

    return result
  }

  async getAllPersonalByConvocatoria(idConvocatoria) {
    try {
      // Agregar timestamp para evitar caché
      const timestamp = new Date().getTime()

      const { data: dataConvocatoriasPersonal } = await axios.get(`${basePath}/convocatoriaPersonal?_t=${timestamp}`)
      const todasConvocatoriasPersonal =
        typeof dataConvocatoriasPersonal.data === 'string'
          ? JSON.parse(dataConvocatoriasPersonal.data)
          : dataConvocatoriasPersonal.data

      const convocatoriasPersonalFiltradas = todasConvocatoriasPersonal.filter(
        (cp) => cp.fk_idConvocatoria === idConvocatoria
      )

      const { data: dataPersonal } = await axios.get(
        `${basePath}/convocatoria/${idConvocatoria}/personal?_t=${timestamp}`
      )
      const personal = typeof dataPersonal.data === 'string' ? JSON.parse(dataPersonal.data) : dataPersonal.data

      const personalCompleto = personal.map((p) => {
        const convocatoriaPersonal = convocatoriasPersonalFiltradas.find((cp) => cp.fk_idPersonal === p.id_personal)

        return {
          ...p,
          idConvocatoriaPersonal: convocatoriaPersonal?.id,
          aceptado: convocatoriaPersonal?.aceptado ?? false,
          promocionado: convocatoriaPersonal?.promocionado ?? false,
        }
      })

      return personalCompleto || []
    } catch (error) {
      throw error
    }
  }
}
